import { apiServiceWrapper } from '../../../../Middleware/API/apiRequest';
import { getTokensFromStorage } from '../../../../Utils/Auth/AuthToken';
import { AUTEST_TEST } from '../../../../constants/apiRoutes';
import {
  getGraphqlCacheResponse,
  setGraphqlCacheResponse,
} from '../../../../Utils/Storage/IndexDB/indexDbWrappers';
import { doubleEncode } from '../../../../Utils/Encode/UrlHelper';
/**
 * list Tests.
 * @returns {Promise} - A promise that resolves with the list of Tests or rejects with an error.
 * @param props
 */
export const listTest = async ({
  accessToken,
  limit,
  offset,
  filter,
  sort,
  moduleName,
  isServiceWorker,
  listController,
}) => {
  const data = {
    Filters: filter,
    pageNumber: offset === 0 ? 1 : offset,
    pageSize: limit,
    sort,
  };

  const response = await apiServiceWrapper({
    url: `${AUTEST_TEST}/filter`,
    method: 'POST',
    moduleName,
    isServiceWorker,
    listController,
    body: data,
    accessToken,
  });
  if (response?.isError) {
    if (isServiceWorker) {
      let cacheResponse = await getGraphqlCacheResponse(
        headers,
        isServiceWorker,
      );
      return cacheResponse;
    }
    return response;
  }
  if (isServiceWorker) {
    await setGraphqlCacheResponse(headers, response, isServiceWorker);
  }
  return {
    tests: response.Payload,
    TotalCount: response?.TotalRecordCount,
  };
};

/**
 * Create Test.
 * @returns {Promise} - A promise that resolves with the creation of test or rejects with an error.
 * @param data
 */
export const createTest = async ({
  data,
  moduleName,
  isServiceWorker,
  listController,
}) => {
  const { accessToken } = getTokensFromStorage();
  const response = await apiServiceWrapper({
    url: `${AUTEST_TEST}`,
    method: 'POST',
    moduleName,
    isServiceWorker,
    listController,
    body: data,
    accessToken,
  });
  return response;
};

/**
 * Update Test.
 * @returns {Promise} - A promise that resolves with the update of test or rejects with an error.
 * @param data
 */
export const updateTest = async ({
  data,
  moduleName,
  isServiceWorker,
  listController,
}) => {
  const { accessToken } = getTokensFromStorage();
  const response = await apiServiceWrapper({
    url: `${AUTEST_TEST}/${doubleEncode(data?.tenant_id)}`,
    method: 'PUT',
    moduleName,
    isServiceWorker,
    listController,
    body: data,
    accessToken,
  });
  return response;
};

/**
 * Update Test.
 * @returns {Promise} - A promise that resolves with the update of test or rejects with an error.
 * @param data
 */
export const deleteTest = async ({
  data,
  moduleName,
  isServiceWorker,
  listController,
}) => {
  const { accessToken } = getTokensFromStorage();
  const response = await apiServiceWrapper({
    url: `${AUTEST_TEST}/${doubleEncode(data?.uc_ossi_app_test_id)}?uc_ossi_prod_id=${encodeURIComponent(data?.uc_ossi_prod_id)}&tenantid=${encodeURIComponent(data?.tenant_id)}&uc_ossi_app_test_id=${encodeURIComponent(data?.uc_ossi_app_test_id)}`,
    method: 'DELETE',
    moduleName,
    isServiceWorker,
    listController,
    body: data,
    accessToken,
  });
  return response;
};

/**
 * get copy Test.
 * @returns {Promise} - A promise that resolves with the update of Test or rejects with an error.
 * @param data
 */
export const getCopyTest = async ({
  data,
  moduleName,
  isServiceWorker,
  listController,
}) => {
  const { accessToken } = getTokensFromStorage();
  const response = await apiServiceWrapper({
    url: `${AUTEST_TEST}/Copy?tenant_id=${data?.tenant_id}&uc_ossi_test_id=${encodeURIComponent(data?.uc_ossi_app_test_id)}`,
    method: 'GET',
    moduleName,
    isServiceWorker,
    listController,
    accessToken,
  });
  return response;
};
/**
 * post copy Test and save in DB.
 * @returns {Promise} - A promise that resolves with the create of Test or rejects with an error.
 * @param data
 */
export const postCopyTest = async ({
  data,
  moduleName,
  isServiceWorker,
  listController,
}) => {
  const { accessToken } = getTokensFromStorage();
  const response = await apiServiceWrapper({
    url: `${AUTEST_TEST}/Copy`,
    method: 'POST',
    body: data,
    moduleName,
    isServiceWorker,
    listController,
    accessToken,
  });
  return response;
};
